export const LEGAL_WHAT_ARE_COOKIES: string = `

## Was sind Cookies?

Ein Cookie ist eine kleine Datenmenge (Textdatei), die eine Website von Ihrem Browser auffordert, auf Ihrem Gerät zu speichern, um Informationen über Sie zu speichern, beispielsweise Ihre Spracheinstellungen oder Anmeldeinformationen. Wir verwenden Cookies und ähnliche Technologien wie Local-Storage oder Pixel (hier gemeinsam als “Cookies” bezeichnet), um Daten als Teil unserer Plattform gemäß der Definition in unserer zu speichern <button class="btn btn-link p-0" routerLink="privacy-policy">Datenschutzrichtlinie</button>.
`;
